export default __webpack_public_path__ + "static/about1-87741d410e44e59efdf1beddca6cf07f.jpeg";